/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date with time (isoformat) */
  DateTime: any;
  UUID: any;
};

export enum ActionTypeEnum {
  DismissAppSettings = 'dismiss_app_settings',
  OpenAppSettings = 'open_app_settings',
  OpenFind = 'open_find',
  OpenHelp = 'open_help',
  OpenMyCategories = 'open_my_categories',
  OpenMyContent = 'open_my_content',
  OpenMyContentRewards = 'open_my_content_rewards',
  OpenMyContentSummary = 'open_my_content_summary',
  OpenMyDailySummary = 'open_my_daily_summary',
  OpenMyFriends = 'open_my_friends',
  OpenMyGroups = 'open_my_groups',
  OpenNotifications = 'open_notifications',
  OpenRecommendedForYou = 'open_recommended_for_you',
  OpenTrendingNow = 'open_trending_now',
  ToggleDrawer = 'toggle_drawer'
}

export type ExternalNavigationAction = {
  __typename?: 'ExternalNavigationAction';
  actionType: ActionTypeEnum;
  url: Scalars['String'];
};

export type GenericNavigationAction = {
  __typename?: 'GenericNavigationAction';
  actionType: ActionTypeEnum;
};

export type Locale = {
  __typename?: 'Locale';
  code: Scalars['String'];
};

export type Menu = {
  __typename?: 'Menu';
  id: Scalars['ID'];
  items: Array<MenuItem>;
};

export enum MenuIconEnum {
  Help = 'help',
  Profile = 'profile',
  Settings = 'settings'
}

export type MenuItem = {
  __typename?: 'MenuItem';
  action?: Maybe<NavigationAction>;
  icon?: Maybe<MenuIconEnum>;
  id: Scalars['ID'];
  items?: Maybe<Array<MenuItem>>;
  title?: Maybe<Scalars['String']>;
  type: MenuItemTypeEnum;
};

export enum MenuItemTypeEnum {
  Group = 'group',
  Item = 'item'
}

export type Mutation = {
  __typename?: 'Mutation';
  registerUser: UserRegisterResponse;
};


export type MutationRegisterUserArgs = {
  identity: Scalars['String'];
  identitySource: Scalars['String'];
};

export type NavigationAction = ExternalNavigationAction | GenericNavigationAction | PageNavigationAction;

export type PageNavigationAction = {
  __typename?: 'PageNavigationAction';
  actionType: ActionTypeEnum;
  pageType: PageTypeEnum;
};

export enum PageTypeEnum {
  Find = 'find',
  MyCategories = 'my_categories',
  MyContent = 'my_content',
  MyContentRewards = 'my_content_rewards',
  MyContentSummary = 'my_content_summary',
  MyDailySummary = 'my_daily_summary',
  MyFriends = 'my_friends',
  MyGroups = 'my_groups',
  RecommendedForYou = 'recommended_for_you',
  TrendingNow = 'trending_now'
}

export type Query = {
  __typename?: 'Query';
  getMenuById: Array<Menu>;
  locales: Array<Locale>;
  tenants: Array<Tenant>;
  timezones: Array<Timezone>;
};


export type QueryGetMenuByIdArgs = {
  ids: Array<Scalars['ID']>;
};

export enum StatusEnum {
  Active = 'active',
  Deleted = 'deleted',
  Inactive = 'inactive'
}

export type Tenant = {
  __typename?: 'Tenant';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  status: StatusEnum;
  tenantId: Scalars['UUID'];
};

export type Timezone = {
  __typename?: 'Timezone';
  name: Scalars['String'];
};

export type UserRegisterResponse = {
  __typename?: 'UserRegisterResponse';
  identity: Scalars['String'];
  identitySource: Scalars['String'];
  userId: Scalars['UUID'];
  userIdentityId: Scalars['UUID'];
};

type NavigationActionFields_ExternalNavigationAction_Fragment = { __typename?: 'ExternalNavigationAction', actionType: ActionTypeEnum, url: string } & { ' $fragmentName'?: 'NavigationActionFields_ExternalNavigationAction_Fragment' };

type NavigationActionFields_GenericNavigationAction_Fragment = { __typename?: 'GenericNavigationAction', actionType: ActionTypeEnum } & { ' $fragmentName'?: 'NavigationActionFields_GenericNavigationAction_Fragment' };

type NavigationActionFields_PageNavigationAction_Fragment = { __typename?: 'PageNavigationAction', actionType: ActionTypeEnum, pageType: PageTypeEnum } & { ' $fragmentName'?: 'NavigationActionFields_PageNavigationAction_Fragment' };

export type NavigationActionFieldsFragment = NavigationActionFields_ExternalNavigationAction_Fragment | NavigationActionFields_GenericNavigationAction_Fragment | NavigationActionFields_PageNavigationAction_Fragment;

export type GetMenuQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetMenuQuery = { __typename?: 'Query', getMenuById: Array<{ __typename: 'Menu', id: string, items: Array<{ __typename: 'MenuItem', id: string, title?: string | null, icon?: MenuIconEnum | null, type: MenuItemTypeEnum, action?: { __typename?: 'ExternalNavigationAction', actionType: ActionTypeEnum, url: string } | { __typename?: 'GenericNavigationAction', actionType: ActionTypeEnum } | { __typename?: 'PageNavigationAction', actionType: ActionTypeEnum, pageType: PageTypeEnum } | null, items?: Array<{ __typename: 'MenuItem', id: string, title?: string | null, icon?: MenuIconEnum | null, type: MenuItemTypeEnum, action?: { __typename?: 'ExternalNavigationAction', actionType: ActionTypeEnum, url: string } | { __typename?: 'GenericNavigationAction', actionType: ActionTypeEnum } | { __typename?: 'PageNavigationAction', actionType: ActionTypeEnum, pageType: PageTypeEnum } | null }> | null }> }> };

export const NavigationActionFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NavigationActionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NavigationAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageNavigationAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"pageType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalNavigationAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericNavigationAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}}]}}]}}]} as unknown as DocumentNode<NavigationActionFieldsFragment, unknown>;
export const GetMenuDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMenu"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMenuById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageNavigationAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"pageType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalNavigationAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericNavigationAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageNavigationAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"pageType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalNavigationAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericNavigationAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMenuQuery, GetMenuQueryVariables>;